// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6ea34528e9d4aa8f1913","655":"160cb131ceaaeac7011e"}[chunkId] + ".js";
};